(function($) {
  const showAllButton = $('#js-show-all-posts');

  if (!showAllButton.length) {
    return;
  }

  const jobPosts = $('.job-posts--collapsable');
  const collapsableClass = 'job-posts--show-all';
  const showAllButtonText = {
    show: mousyLocalize.showPosts,
    hide: mousyLocalize.hidePosts,
  };

  showAllButton.click(function(e) {
    e.preventDefault();

    if (jobPosts.hasClass(collapsableClass)) {
      jobPosts.removeClass(collapsableClass);
      showAllButton.html(showAllButtonText.show);
    } else {
      jobPosts.addClass(collapsableClass);
      showAllButton.html(showAllButtonText.hide);
    }
  });
  
})(jQuery);
